<template>
  <div class="dashboard background">
    <toast />
    <dashboard-page pcontent="1" page="COURSES">
      <!-- course manager  -->
      <card w='80%' minWidth='1050px' v-if='true'>
        <!-- card header -->
        <div class='fRow fullWidth jStart aCenter'>
          <div class='growFull fCol jStart aStart'>
            <h3 class='growFull text-right'>مدیریت آزمون‌ها</h3>
            <p class='note'>آزمون جدید اضافه کنید، آزمون‌های قبلی را مدیریت کنید
              و یا بانک سؤالات را ویرایش کنید.
            </p>
          </div>
          <btn isMini='true' label='به‌روز رسانی' bc='#667089'
            style="margin: 8px !important;"
            v-if="false"
            icon='keyboard_arrow_left' @click.native="backToCourse"/>
        </div>
        <div class="tabHeader fRow jCenter aCenter fullWidth" id="tab">
          <a @click="toggleSection('list')"
            class="tabBtn fRow jCenter aCenter
            w25 transition-fast" v-bind:class="{selected: isExamList}">
            <i class="material-icons-round transition-fast">reorder</i>
            <span class="transition-fast">لیست آزمون‌های ثبت شده</span>
          </a>
          <a @click="toggleSection('new')"
            class="tabBtn fRow jCenter aCenter
            w25 transition-fast" v-bind:class="{selected: isNewExam}">
            <i class="material-icons-round transition-fast">receipt_long</i>
            <span class="transition-fast">ایجاد آزمون جدید</span>
          </a>
          <a @click="toggleSection('bank')"
            class="tabBtn fRow jCenter aCenter
            w25 transition-fast" v-bind:class="{selected: isBank}">
            <i class="material-icons-round transition-fast">dynamic_form</i>
            <span class="transition-fast">بانک سؤالات آزمون</span>
          </a>
          <a @click="toggleSection('subcats')"
            class="tabBtn fRow jCenter aCenter
            w25 transition-fast" v-bind:class="{selected: isSubcats}">
            <i class="material-icons-round transition-fast">dynamic_form</i>
            <span class="transition-fast">طبقه بندی‌ها</span>
          </a>
        </div>
        <!-- صفحه اضافه کردن آزمون -->
        <div class="newExam fCol jStart aCenter fullWidth"
          v-if='isNewExam' id="uploaders">
          <div class="rules fullWidth fRow jStart aStart wrap">
            <h3>قوانین و مقررات ایجاد آزمون</h3>
            <div class="ruleBox fCol jStart aStart w25">
              <h4>آزمون هماهنگ</h4>
              <p>آزمون‌های هماهنگ تنها در تاریخ و ساعت تعیین شده قابل دسترسی هستند</p>
              <p>نمایش نتایج آزمون‌های هماهنگ پس از تأیید آموزشگاه انجام می‌پذیرد</p>
            </div>
            <div class="ruleBox fCol jStart aStart w25">
              <h4>آزمون تمرینی</h4>
              <p>آزمون‌های تمرینی همیشه در دسترس هستند</p>
              <p>نتایج آزمون‌های تمرینی بلافاصله بعد از اتمام آزمون انجام می‌پذیرد</p>
            </div>
            <div class="ruleBox fCol jStart aStart w25">
              <h4>بانک سؤالات</h4>
              <p>سؤالات آزمون را از بین سؤالات ثبت شده در بانک انتخاب کنید</p>
              <p>در صورتی که سؤال مد نظر در بانک موجود نیست سؤال جدید را به بانک سؤال اضافه کنید
              </p>
            </div>
            <div class="ruleBox fCol jStart aStart w25">
              <h4>سختی آزمون</h4>
              <p>سختی آزمون به صورت اتوماتیک از بین سؤالاتی که انتخاب می‌کنید
                مشخص می‌شود.
              </p>
            </div>
          </div>
          <!-- فرم اضافه کردن آزمون -->
          <div class="fRow jBetween aStart fullWidth">
            <!-- add exam component here -->
            <add-exam mode="add" :init="''"/>
          </div>
        </div>
        <!-- صفحه مشاهده آزمون ها -->
        <div class="examsList fRow jBetween aStart fullWidth wrap ltr"
          id='list' v-if="isExamList">
          <div class="rules fullWidth fRow jStart aStart wrap">
            <h3>مشاهده، ویرایش و حذف آزمون‌های ثبت شده</h3>
            <div class="ruleBox fCol jStart aStart fullWidth">
              <h4>با استفاده از فیلترهای موجود آزمون مورد نظر را بیابید</h4>
            </div>
          </div>
          <!-- نمایش آزمون ها -->
          <show-exam />
        </div>
        <!-- صفحه بانک سؤال -->
        <div class="bank fRow jBetween aStart fullWidth"
          id='list' v-if="isBank">
          <div class="addQuestion fRow jBetween aStart wrap growFull">
            <upload-excel v-if="false"/>
            <div class="fRow jBetween aStart fullWidth wrap"
              v-if="(!qEditMode) || (qEditMode && letEdit)">
              <h4 class="fullWidth">فرم اضافه کردن سؤال جدید به بانک سؤالات</h4>
              <div class="filterBox w50 fRow jStart aCenter">
                <div class="ih fullWidth fCol jStart aStart">
                  <span>انتخاب سطح سؤال</span>
                  <cool-select
                    class="fullWidth"
                    v-model="qLevel"
                    disable-search
                    :items="questionLevels"/>
                </div>
              </div>
              <div class="filterBox w50 fRow jStart aCenter">
                <div class="ih fullWidth fCol jStart aStart">
                  <span>انتخاب نوع سؤال</span>
                  <cool-select
                    class="fullWidth"
                    v-model="questionTypeSelected"
                    disable-search
                    :items="questionTypes"/>
                </div>
              </div>
              <div class="filterBox w50 fRow jStart aCenter">
                <div class="ih fullWidth fCol jStart aStart">
                  <span>انتخاب رشته</span>
                  <cool-select
                    class="fullWidth"
                    @select="selected($event, 'addQuestionField')"
                    v-model="questionSelectedField"
                    disable-search
                    :items="fields"
                    :item-value="fields.id"
                    :item-text="fields.title">
                    <!-- slot for each item in the menu -->
                    <template slot="item" slot-scope="{ item: fields }">
                      <div style="display: flex; align-items: center;">
                        <div>
                          {{ fields.title }}
                        </div>
                      </div>
                    </template>
                    <!-- slot for the selected item (in the text field) -->
                    <template slot="selection" slot-scope="{ item: fields }">
                      <div>
                        {{ fields.title }}
                      </div>
                    </template>
                  </cool-select>
                </div>
              </div>
              <div class="filterBox w50 fRow jStart aCenter">
                <div class="ih fullWidth fCol jStart aStart">
                  <span>انتخاب پایه</span>
                  <cool-select
                    class="fullWidth"
                    @select="selected($event, 'addQuestionGrade')"
                    v-model="questionGradeSelected"
                    disable-search
                    :items="grades"
                    :item-value="grades.id"
                    :item-text="grades.title">
                    <!-- slot for each item in the menu -->
                    <template slot="item" slot-scope="{ item: grade }">
                      <div style="display: flex; align-items: center;">
                        <div>
                          {{ grade.title }}
                          <b>{{ grade.value }}</b>
                        </div>
                      </div>
                    </template>
                    <!-- slot for the selected item (in the text field) -->
                    <template slot="selection" slot-scope="{ item: grade }">
                      <div>
                        {{ grade.title }}
                        <b>{{ grade.value }}</b>
                      </div>
                    </template>
                  </cool-select>
                </div>
              </div>
              <div class="filterBox w50 fRow jStart aCenter">
                <div class="ih fullWidth fCol jStart aStart">
                  <span>انتخاب درس</span>
                  <cool-select
                    class="fullWidth"
                    @select="selected($event, 'addQuestionLesson')"
                    v-model="questionLessonSelected"
                    disable-search
                    :items="lessons"
                    :item-value="lessons.id"
                    :item-text="lessons.title">
                    <!-- slot for each item in the menu -->
                    <template slot="item" slot-scope="{ item: lesson }">
                      <div style="display: flex; align-items: center;">
                        <div>
                          {{ lesson.title }}
                          <b>{{ lesson.value }}</b>
                        </div>
                      </div>
                    </template>
                    <!-- slot for the selected item (in the text field) -->
                    <template slot="selection" slot-scope="{ item: lesson }">
                      <div>
                        {{ lesson.title }}
                        <b>{{ lesson.value }}</b>
                      </div>
                    </template>
                  </cool-select>
                </div>
              </div>
              <div class="filterBox w50 fRow jStart aCenter">
                <div class="ih fullWidth fCol jStart aStart">
                  <span>انتخاب طبقه‌بندی</span>
                  <cool-select
                    class="fullWidth"
                    @select="selected($event, 'addQuestionClassification')"
                    v-model="questionClassificationSelected"
                    :items="classifications"
                    :item-value="classifications.id"
                    :item-text="classifications.title">
                    <!-- slot for each item in the menu -->
                    <template slot="item" slot-scope="{ item: classifications }">
                      <div style="display: flex; align-items: center;">
                        <div>
                          {{ classifications.title }}
                          <b>{{ classifications.value }}</b>
                        </div>
                      </div>
                    </template>
                    <!-- slot for the selected item (in the text field) -->
                    <template slot="selection" slot-scope="{ item: classifications }">
                      <div>
                        {{ classifications.title }}
                        <b>{{ classifications.value }}</b>
                      </div>
                    </template>
                  </cool-select>
                </div>
              </div>
            </div>
            <!-- متن سؤال -->
            <div class="fullWidth fCol jStart align-self-start Q"
              style="margin-bottom: 0; margin-top: 16px">
              <span class="fRow jStart aCenter sectionHead">
                <i class="material-icons-round">help</i>متن سؤال
                <div class="fRow jEnd aCenter growFull">
                  <a href="https://katex.org/docs/support_table.html"
                    class="howToFormula"
                    target="_blank">آموزش نوشتن فرمول</a>
                </div>
              </span>
              <div class="fRow jStart aCenter fullWidth inputWraper">
                <textarea
                  v-if="false"
                  style="height: 88px"
                  class="transition-fast" placeholder="متن سؤال"
                  type="text" v-model="question"></textarea>
              </div>
              <quill-editor ref="myTextEditor"
                class="fullWidth qlClass inputWraper"
                v-model="question"
                :options="quillOptions">
              </quill-editor>
              <get-photo-exam
                w='100%'
                v-on:photoupload="getUploaded($event, 'question')"
                photoFor='question'
                :initImg='questionMedia'
                uploadMsg='الزامی نیست'
                uploadLabel='تصویر یا فایل ورد مربوط به سؤال'/>
            </div>
            <!-- گزینه اول -->
            <div class="w50 fCol jStart aStart inputHolder QO"
              v-if="isTestQuestion"
              style="margin-bottom: 0;">
              <span class="fRow jStart aCenter"><i class="material-icons-round">check_box</i>
                گزینه‌ی الف</span>
              <div class="fRow jStart aCenter fullWidth inputWraper">
                <i class="isTrueCheckBox material-icons-round transition-fast"
                  @click="testTrueAnswer = 'A'"
                  v-bind:class="{selected: testTrueAnswer === 'A'}">
                  <div class="tick transition-fast"></div>
                </i>
                <!-- <textarea class="transition-fast qo" placeholder="گزینه‌ی الف"
                  v-model="testA"></textarea> -->
                <quill-editor
                  class="fullWidth qlClass"
                  v-model="testA"
                  :options="qItemQuillOptions"></quill-editor>
              </div>
              <get-photo-exam
                w='100%'
                v-on:photoupload="getUploaded($event, 'A')"
                photoFor='testA'
                :initImg='testAMedia'
                uploadMsg='تصویر گزینه‌ی الف'
                uploadLabel=''/>
            </div>
            <!-- گزینه دوم -->
            <div class="w50 fCol jStart aStart inputHolder QO"
              v-if="isTestQuestion"
              style="margin-bottom: 0;">
              <span class="fRow jStart aCenter"><i class="material-icons-round">help</i>
                گزینه‌ی ب</span>
              <div class="fRow jStart aCenter fullWidth inputWraper">
                <i class="isTrueCheckBox material-icons-round transition-fast"
                  @click="testTrueAnswer = 'B'"
                  v-bind:class="{selected: testTrueAnswer === 'B'}">
                  <div class="tick transition-fast"></div>
                </i>
                <!-- <textarea class="transition-fast qo" placeholder="گزینه‌ی ب"
                  v-model="testB"></textarea> -->
                <quill-editor
                  class="fullWidth qlClass"
                  v-model="testB"
                  :options="qItemQuillOptions"></quill-editor>
              </div>
              <get-photo-exam
                w='100%'
                v-on:photoupload="getUploaded($event, 'B')"
                photoFor='testB'
                :initImg='testBMedia'
                uploadMsg='تصویر گزینه‌ی ب'
                uploadLabel=''/>
            </div>
            <!-- گزینه سوم -->
            <div class="w50 fCol jStart aStart inputHolder QO"
              v-if="isTestQuestion"
              style="margin-bottom: 0;">
              <span class="fRow jStart aCenter"><i class="material-icons-round">help</i>
                گزینه‌ی ج</span>
              <div class="fRow jStart aCenter fullWidth inputWraper">
                <i class="isTrueCheckBox material-icons-round transition-fast"
                  @click="testTrueAnswer = 'C'"
                  v-bind:class="{selected: testTrueAnswer === 'C'}">
                  <div class="tick transition-fast"></div>
                </i>
                <!-- <textarea class="transition-fast qo" placeholder="گزینه‌ی ج"
                  v-model="testC"></textarea> -->
                <quill-editor
                  class="fullWidth qlClass"
                  v-model="testC"
                  :options="qItemQuillOptions"></quill-editor>
              </div>
              <get-photo-exam
                w='100%'
                v-on:photoupload="getUploaded($event, 'C')"
                photoFor='testC'
                :initImg='testCMedia'
                uploadMsg='تصویر گزینه‌ی ج'
                uploadLabel=''/>
            </div>
            <!-- گزینه چهارم -->
            <div class="w50 fCol jStart aStart inputHolder QO"
              v-if="isTestQuestion"
              style="margin-bottom: 0;">
              <span class="fRow jStart aCenter"><i class="material-icons-round">help</i>
                گزینه‌ی د</span>
              <div class="fRow jStart aCenter fullWidth inputWraper">
                <i class="isTrueCheckBox material-icons-round transition-fast"
                  @click="testTrueAnswer = 'D'"
                  v-bind:class="{selected: testTrueAnswer === 'D'}">
                  <div class="tick transition-fast"></div>
                </i>
                <!-- <textarea class="transition-fast qo" placeholder="گزینه‌ی د"
                  v-model="testD"></textarea> -->
                <quill-editor ref="myTextEditor"
                  class="fullWidth qlClass"
                  v-model="testD"
                  :options="qItemQuillOptions"></quill-editor>
              </div>
              <get-photo-exam
                w='100%'
                v-on:photoupload="getUploaded($event, 'D')"
                photoFor='testD'
                :initImg='testDMedia'
                uploadMsg='تصویر گزینه‌ی د'
                uploadLabel=''/>
            </div>
            <div class="fRow jStart aCenter fullWidth"
              style="margin: 16px 0">
              <div class="b fRow jStart aCenter big"
                @click="newQuestion"
                v-if="!qEditMode"
                v-bind:class="{active: isAddQuestionReady}">
                <i class="material-icons-round">add</i>
                <label>اضافه کردن سؤال</label>
              </div>
              <div class="b fRow jStart aCenter big"
                @click="editQuestions"
                v-if="qEditMode"
                v-bind:class="{active: isEditQuestionReady}">
                <i class="material-icons-round">edit</i>
                <label>ویرایش سؤال</label>
              </div>
              <div class="b fRow jStart aCenter"
                v-if="qEditMode"
                @click="clearQuestion">
                <i class="material-icons-round">close</i>
                <label>بازگشت و ایجاد سؤال جدید</label>
              </div>
              <div class="b fRow jStart aCenter"
                v-if="!qEditMode"
                @click="clearQuestion">
                <i class="material-icons-round">delete</i>
                <label>پاک کردن فرم</label>
              </div>
            </div>
          </div>
          <question-bank from='exam'/>
        </div>
        <!-- طبقه بندی ها -->
        <div class="newExam fRow jBetween aStart fullWidth wrap" v-if="isSubcats">
          <h4 class="fullWidth">ثبت و ویرایش طبقه‌بندی سؤالات</h4>
          <div class="w50 fRow jBetween aCenter">
            <!-- عنوان طبقه بندی -->
            <div class="growFull fCol jStart aStart inputHolder"
              style="margin-bottom: 0;">
              <span class="fRow jStart aCenter">
                <i class="material-icons-round">category</i>
                عنوان طبقه بندی</span>
              <div class="fRow jStart aCenter fullWidth inputWraper">
                <input class="transition-fast growFull"
                  placeholder="عنوان طبقه‌بندی"
                  @keyup.enter="newClassification"
                  style="width: unset; margin-left: 8px !important"
                  type="text" v-model="subcatName"/>
                <div class="b fRow jStart aCenter"
                  @click="newClassification"
                  v-bind:class="{active: subCatErr}">
                  <i class="material-icons-round">done_all</i>
                  <label>اضافه کردن طبقه‌بندی</label>
                </div>
              </div>
            </div>
          </div>
          <!-- لیست طبقه بندی‌ها -->
          <div class="w50 fRow jBetween aCenter wrap minilist">
            <div class="fRow jStart aCenter heads">
              <i class="material-icons-round">account_circle</i>
              لیست طبقه‌بندی
            </div>
            <div class="fCol jCenter aCenter fullWidth"
              v-if="loading || noContent">
              <p-bar
                :loading="loading"
                :notYet="notYet"
                :noContent="noContent"
                :notFound="notFound"
                :error="error" />
            </div>
            <ul class="fullWidth minilistUl" v-if="!loading && !noContent">
              <li class="fRow jStart aCenter"
                v-for="(item, index) in classifications" v-bind:key="index">
                <subcat-item
                  :data="item"
                  :indexs="index"
                  @refresh="getClassification"/>
              </li>
            </ul>
          </div>
        </div>
      </card>
    </dashboard-page>
    <tool-bar/>
    <right-menu/>
    <modal v-if="modalShow">
      <card w="580px">
        <label class="question">با ترک این صفحه آپلودها متوقف می‌شوند.
          آیا مایل به ترک این صفحه هستید؟</label>
        <div class="fullWidth wrap aStart jStart fRow btnRow">
          <btn label="نمایش لیست ویدئوها" btnWidth='236px' bc='#ff0533'
          icon="delete_sweep" @click.native="showListAnyWay"/>
          <keep-alive>
            <btn fabBtn='true' label="بازگشت" btnWidth='auto'
              @click.native="closeModal" bc='#aaaaaa' icon="close"/>
          </keep-alive>
        </div>
      </card>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import RightMenu from '@/components/RightMenu.vue';
import ToolBar from '@/components/ToolBar.vue';
import DashboardPage from '@/components/DashboardPage.vue';
import Card from '@/components/Card.vue';
import Btn from '@/components/Btn.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import Toast from '@/components/Toast.vue';
import SubcatItem from '@/components/SubcatItem.vue';
import ticks from '@/mixins/ticks';
import Modal from '@/components/Modal.vue';
import { CoolSelect } from 'vue-cool-select';
import 'vue-cool-select/dist/themes/material-design-dark.scss';
import '@/assets/new.scss';
import QuestionBank from '@/components/QuestionBank.vue';
import UploadExcel from '@/components/UploadExcel.vue';
import GetPhotoExam from '@/components/GetPhotoExam.vue';
import AddExam from '@/components/AddExam.vue';
import ShowExam from '@/components/ShowExam.vue';
import { EventBus } from '@/plugins/event-bus';
import pBar from '@/components/pBar.vue';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import katex from 'katex';
import 'katex/dist/katex.min.css';

export default {
  mixins: [errorHandler, makeToast, ticks],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      isNewExam: false,
      isExamList: false,
      isBank: true,
      isSubcats: false,
      justClassification: false,
      optionalClassification: false,
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: false,
      loaded: true,
      modeMsg: '',
      // modes ↑
      // add question form
      isTestQuestion: true,
      question: '',
      questionErr: true,
      questionMedia: '',
      questionMediaInit: '',
      testTrueAnswer: '',
      tTrueAnsErr: true,
      testA: '',
      testAErr: true,
      testAMedia: '',
      testAMediaInit: '',
      testB: '',
      testBErr: true,
      testBMedia: '',
      testBMediaInit: '',
      testC: '',
      testCErr: true,
      testCMedia: '',
      testCMediaInit: '',
      testD: '',
      testDErr: true,
      testDMedia: '',
      testDMediaInit: '',
      questionTypes: [
        'تستی',
        'تشریحی',
      ],
      questionTypeSelected: 'تستی',
      qTypeSelectedErr: false,
      questionLevels: [
        'آسان',
        'متوسط',
        'سخت',
      ],
      qLevel: '',
      qLevelErr: true,
      fields: [
        {
          id: '',
          title: 'حذف فیلتر',
        },
        {
          id: 0,
          title: 'متوسطه‌ی اول',
        },
        {
          id: 1,
          title: 'ریاضی',
        },
        {
          id: 2,
          title: 'تجربی',
        },
        {
          id: 3,
          title: 'انسانی',
        },
        {
          id: 4,
          title: 'فنی',
        },
        {
          id: 5,
          title: 'زبان',
        },
        {
          id: 6,
          title: 'هنر',
        },
      ],
      questionSelectedField: '',
      qSelectedFieldErr: true,
      grades: [
        'لطفا رشته را انتخاب کنید',
      ],
      questionGradeSelected: '',
      qSelectedGradeId: '',
      qSelectedGradeIdErr: true,
      lessons: [
        'لطفا درس را انتخاب کنید',
      ],
      questionLessonSelected: '',
      qLessonId: '',
      qLessonIdErr: true,
      classifications: [
        'لطفا طبقه بندی را انتخاب کنید',
      ],
      questionClassificationSelected: '',
      qClassificationId: '',
      qClassificationIdErr: true,
      // list
      rangeStart: '',
      rangeEnd: '',
      examTypes: [
        'هماهنگ',
        'غیر هماهنگ',
      ],
      listSearchType: '',
      listSearchField: '',
      listSearchGrade: '',
      // subcats
      subcatName: '',
      // other
      modalShow: false,
      qEditMode: false,
      letEdit: false,
      editQuestionId: '',
      editQuestionType: -1,
      // editor data
      name: 'app',
      content: '<p></p>',
      quillOptions: {
        placeholder: 'متن سؤال را وارد کنید',
        modules: {
          toolbar: [
            [{ size: [] }],
            // [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'underline', 'strike'],
            [{ color: [] }, { background: [] }],
            [{ script: 'super' }, { script: 'sub' }],
            // ['blockquote', 'code-block'],
            // [{ header: '1' }, { header: '2' }, 'blockquote', 'code-block'],
            // [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
            // [{ direction: 'ltr' }, { align: [] }, 'formula'],
            ['image', 'formula'],
            ['clean'],
          ],
        },
      },
      qItemQuillOptions: {
        placeholder: 'متن گزینه را وارد کنید',
        modules: {
          toolbar: [
            ['formula', 'clean'],
            ['bold', 'underline'],
            [{ color: [] }, { background: [] }],
          ],
        },
      },
    };
  },
  methods: {
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    backToCourse() {
      this.$store.commit('resetCourseObject');
      this.$router.push('/courses');
    },
    closeModal() {
      this.modalShow = false;
    },
    showListAnyWay() {
      this.isVideoUploading = false;
      this.modalShow = false;
      this.toggleSection('list');
    },
    toggleSection(order) {
      this.isNewExam = false;
      this.isExamList = false;
      this.isBank = false;
      this.isSubcats = false;
      switch (order) {
        case 'new': {
          this.isNewExam = true;
          break;
        }
        case 'list': {
          this.isExamList = true;
          break;
        }
        case 'bank': {
          this.isBank = true;
          break;
        }
        case 'subcats': {
          this.isSubcats = true;
          break;
        }
        default:
          break;
      }
    },
    clearSelected() {
      this.examQuestions = [];
      EventBus.$emit('clearSelected');
    },
    deleteQuestion(id) {
      if (this.findInArray(id) !== -1) {
        this.examQuestions.splice(this.findInArray(id), 1);
      }
      EventBus.$emit('updateBankSelected', this.examQuestions);
    },
    findInArray(id) {
      let ind = -1;
      for (let i = 0; i < this.examQuestions.length; i += 1) {
        if (this.examQuestions[i].id === id) {
          ind = i;
        }
      }
      return ind;
    },
    getUploaded(e, item) {
      switch (item) {
        case 'question': {
          this.questionMedia = e;
          break;
        }
        case 'A': {
          this.testAMedia = e;
          break;
        }
        case 'B': {
          this.testBMedia = e;
          break;
        }
        case 'C': {
          this.testCMedia = e;
          break;
        }
        case 'D': {
          this.testDMedia = e;
          break;
        }
        default:
          break;
      }
    },
    // dynamic fields
    getFields() {
      this.fields = [
        {
          id: -1,
          title: 'کمی صبر کنید',
        },
      ];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Fields`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        const f = response.data.data;
        if (response.data.isSuccess) {
          if (f.length === 0) {
            this.filterGrade = {};
            this.filterLesson = {};
            this.grades = [
              {
                id: -1,
                title: 'ابتدا رشته را انتخاب کنید',
              },
            ];
            this.lessons = [
              {
                id: -1,
                title: 'ابتدا رشته را انتخاب کنید',
              },
            ];
            this.fields = [
              {
                id: -1,
                title: 'هیچ رشته‌ای ثبت نشده',
              },
            ];
          } else {
            // this.classGradeErr = true;
            this.questionGradeSelected = {};
            // this.classLessonErr = true;
            this.questionLessonSelected = {};
            this.fields = [];
            for (let i = 0; i < f.length; i += 1) {
              const item = {
                id: f[i].id,
                title: f[i].title,
              };
              this.fields.push(item);
            }
            // خالی نیست
          }
        } else {
          this.makeToast('error', 'خطا در دریافت رشته‌ها', 3000);
          this.classFields = [
            {
              id: -1,
              title: 'خطا در دریافت رشته‌ها',
            },
          ];
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.classFields = [
          {
            id: -1,
            title: this.errorHandler(error),
          },
        ];
      });
    },
    getGrades(f) {
      this.grades = [{
        id: -1,
        title: 'لطفا صبر کنید',
      }];
      let reqUrl = `${this.baseURL}/api/v${this.V}/Grades?fieldId=${f}`;
      if (f !== undefined) {
        reqUrl = `${this.baseURL}/api/v${this.V}/Grades?fieldId=${f}`;
      } else {
        this.grades = [{
          id: -1,
          title: 'رشته را انتخاب کنید',
        }];
        this.lessons = [{
          id: -1,
          title: 'رشته و پایه را انتخاب کنید',
        }];
        return;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.grades = [];
          const arr = response.data.data;
          for (let i = 0; i < arr.length; i += 1) {
            this.grades.push({
              id: arr[i].id,
              title: arr[i].title,
            });
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    getLesson(f) {
      this.lessons = ['لطفا صبر کنید'];
      let reqUrl = `${this.baseURL}/api/v${this.V}/Lessons`;
      if (f !== 0) {
        reqUrl = `${this.baseURL}/api/v${this.V}/Lessons?gradeId=${f}`;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.lessons = [];
          const arr = response.data.data;
          for (let i = 0; i < arr.length; i += 1) {
            this.lessons.push({
              id: arr[i].id,
              title: arr[i].title,
            });
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    getClassification() {
      this.setMode('loading');
      this.classifications = [{
        title: 'لطفا صبر کنید',
        id: '',
      }];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Questions/classification`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.classifications = [];
          const arr = response.data.data;
          if (arr.length === 0) {
            if (this.isSubcats) {
              this.setMode('noContent');
            }
            // ریست کردن لیست ها
            this.classifications = [{
              title: 'طبقه‌بندی ثبت نشده',
              id: '',
            }];
          } else {
            for (let i = 0; i < arr.length; i += 1) {
              this.classifications.push({
                id: arr[i].id,
                title: arr[i].name,
              });
            }
            this.setMode('loaded');
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.setMode('error', this.errorHandler(error));
        // console.log(error);
      }).catch(() => {
        this.setMode('error', 'در صورت درستی اتصال اینترنت، با تیم فنی تماس بگیرید');
      });
    },
    newClassification() {
      if (this.subcatName !== '') {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Questions/classification`;
        axios({
          method: 'post',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            name: this.subcatName,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.getClassification();
            this.makeToast('success', 'طبقه‌بندی با موفقیت ثبت شد', 3000);
            this.subcatName = '';
          } else {
            this.makeToast('error', 'مشکلی پیش آمده، دوباره تلاش کنید', 3000);
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
          this.editMode = false;
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
          this.editMode = false;
        });
      } else {
        this.makeToast('error', 'ابتدا نام طبقه بندی را ویرایش کنید', 3000);
      }
    },
    newQuestion() {
      if (this.isAddQuestionReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Questions`;
        let qt = 0;
        let q = [];
        let l = 0;
        switch (this.qLevel) {
          case 'سخت': {
            l = 1;
            break;
          }
          case 'متوسط': {
            l = 2;
            break;
          }
          case 'آسان': {
            l = 3;
            break;
          }
          default:
            break;
        }
        if (this.questionTypeSelected === 'تستی') {
          qt = 1;
          q = [
            {
              text: this.testA,
              media: this.testAMedia,
              correctAnswer: this.testTrueAnswer === 'A',
            },
            {
              text: this.testB,
              media: this.testBMedia,
              correctAnswer: this.testTrueAnswer === 'B',
            },
            {
              text: this.testC,
              media: this.testCMedia,
              correctAnswer: this.testTrueAnswer === 'C',
            },
            {
              text: this.testD,
              media: this.testDMedia,
              correctAnswer: this.testTrueAnswer === 'D',
            },
          ];
        } else {
          qt = 2;
          q = [];
        }
        axios({
          method: 'post',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            classificationId: this.qClassificationId !== '' ? this.qClassificationId : null,
            text: this.question,
            media: this.questionMedia,
            options: q,
            field: this.optionalClassification ? parseInt(this.questionSelectedField.id, 10) : -1,
            gradeId: this.optionalClassification ? this.qSelectedGradeId : null,
            lessonId: this.optionalClassification ? this.qLessonId : null,
            level: l,
            type: qt,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.clearQuestion();
          } else {
            this.responseFalse = true;
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
        });
      }
    },
    editQuestions() {
      if (this.isEditQuestionReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Questions/${this.editQuestionId}`;
        let q = [];
        if (this.editQuestionType) {
          q = [
            {
              text: this.testA,
              media: this.testAMedia,
              correctAnswer: this.testTrueAnswer === 'A',
            },
            {
              text: this.testB,
              media: this.testBMedia,
              correctAnswer: this.testTrueAnswer === 'B',
            },
            {
              text: this.testC,
              media: this.testCMedia,
              correctAnswer: this.testTrueAnswer === 'C',
            },
            {
              text: this.testD,
              media: this.testDMedia,
              correctAnswer: this.testTrueAnswer === 'D',
            },
          ];
        } else {
          q = [];
        }
        axios({
          method: 'put',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            text: this.question,
            media: this.questionMedia,
            options: q,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.clearQuestion();
            this.letEdit = false;
            this.qEditMode = false;
            EventBus.$emit('refreshQuestionBank');
          } else {
            this.responseFalse = true;
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
        });
      }
    },
    clearQuestion() {
      this.question = '';
      this.questionMedia = '';
      this.testTrueAnswer = '';
      this.testA = '';
      this.testAMedia = '';
      this.testB = '';
      this.testBMedia = '';
      this.testC = '';
      this.testCMedia = '';
      this.testD = '';
      this.testDMedia = '';
      this.qEditMode = false;
      this.letEdit = false;
      // this.qLevel = '';
      // this.questionSelectedField = '';
      // this.questionGradeSelected = '';
      // this.qSelectedGradeId = '';
      // this.questionLessonSelected = '';
      // this.qLessonId = '';
      EventBus.$emit('clearPhoto');
    },
    selected(e, dropDown) {
      switch (dropDown) {
        case 'addQuestionGrade': {
          this.qSelectedGradeId = this.questionGradeSelected.id;
          if (this.qSelectedGradeId !== '') {
            this.getLesson(this.qSelectedGradeId);
          }
          break;
        }
        case 'addQuestionField': {
          this.getGrades(this.questionSelectedField.id);
          break;
        }
        case 'addQuestionLesson': {
          this.qLessonId = this.questionLessonSelected.id;
          break;
        }
        case 'addQuestionClassification': {
          this.qClassificationId = this.questionClassificationSelected.id;
          break;
        }
        default:
          break;
      }
    },
    initEdit(question) {
      this.editQuestionId = question.id;
      this.editQuestionType = question.isTest;
      this.qEditMode = true;
      this.letEdit = false;
      this.question = question.title;
      this.questionMedia = question.img;
      this.getUploaded(this.questionMedia, 'question');
      this.testA = question.options[0].text;
      this.testAMedia = question.options[0].media;
      this.getUploaded(this.testAMedia, 'A');
      this.testB = question.options[1].text;
      this.testBMedia = question.options[1].media;
      this.getUploaded(this.testBMedia, 'B');
      this.testC = question.options[2].text;
      this.testCMedia = question.options[2].media;
      this.getUploaded(this.testCMedia, 'C');
      this.testD = question.options[3].text;
      this.testDMedia = question.options[3].media;
      this.getUploaded(this.testDMedia, 'D');
      // options
      for (let i = 0; i <= 3; i += 1) {
        if (question.options[i].correctAnswer) {
          switch (i) {
            case 0: {
              this.testTrueAnswer = 'A';
              break;
            }
            case 1: {
              this.testTrueAnswer = 'B';
              break;
            }
            case 2: {
              this.testTrueAnswer = 'C';
              break;
            }
            case 3: {
              this.testTrueAnswer = 'D';
              break;
            }
            default:
              break;
          }
        }
      }
    },
    setClassification(jc, oc) {
      this.justClassification = jc;
      this.optionalClassification = oc;
    },
  },
  components: {
    RightMenu,
    ToolBar,
    DashboardPage,
    Card,
    Btn,
    Toast,
    Modal,
    UploadExcel,
    CoolSelect,
    SubcatItem,
    QuestionBank,
    GetPhotoExam,
    AddExam,
    ShowExam,
    pBar,
    quillEditor,
  },
  watch: {
    questionTypeSelected() {
      if (this.questionTypeSelected === 'تستی') {
        this.isTestQuestion = true;
      } else {
        this.isTestQuestion = false;
      }
    },
    questionSelectedField() {
      this.lessons = [];
      this.qLessonIdErr = true;
      if (this.questionSelectedField === '') {
        this.eField = -1;
        this.grades = [];
        this.qSelectedGradeId = '';
        this.qSelectedGradeIdErr = true;
        this.qSelectedFieldErr = true;
      } else {
        switch (this.questionSelectedField) {
          case 'حذف فیلتر': {
            this.eField = -1;
            break;
          }
          case 'متوسطه‌ی اول': {
            this.eField = 0;
            break;
          }
          case 'ریاضی': {
            this.eField = 1;
            break;
          }
          case 'تجربی': {
            this.eField = 2;
            break;
          }
          case 'انسانی': {
            this.eField = 3;
            break;
          }
          case 'فنی': {
            this.eField = 4;
            break;
          }
          case 'هنر': {
            this.eField = 1;
            break;
          }
          case 'زبان': {
            this.eField = 1;
            break;
          }
          default:
            break;
        }
        this.qSelectedFieldErr = false;
      }
    },
    questionGradeSelected() {
      if (this.questionGradeSelected === '') {
        this.lessons = [];
      } else {
        switch (this.questionSelectedField) {
          case 'زبان': {
            this.eField = 1;
            break;
          }
          default:
            break;
        }
      }
    },
    qSelectedGradeId() {
      if (this.qSelectedGradeId === '') {
        this.qSelectedGradeIdErr = true;
      } else {
        this.qSelectedGradeIdErr = false;
      }
    },
    qClassificationId() {
      if (this.qClassificationId === '') {
        this.qClassificationIdErr = true;
      } else {
        this.qClassificationIdErr = false;
      }
    },
    question() {
      this.content = this.question;
      if (this.question === '') {
        this.questionErr = true;
      } else {
        this.questionErr = false;
      }
    },
    testTrueAnswer() {
      if (this.testTrueAnswer === '') {
        this.tTrueAnsErr = true;
      } else {
        this.tTrueAnsErr = false;
      }
    },
    testA() {
      if (this.questionTypeSelected === 'تستی') {
        if (this.testA === '') {
          this.testAErr = true;
        } else {
          this.testAErr = false;
        }
      } else {
        this.testAErr = false;
      }
    },
    testB() {
      if (this.questionTypeSelected === 'تستی') {
        if (this.testB === '') {
          this.testBErr = true;
        } else {
          this.testBErr = false;
        }
      } else {
        this.testBErr = false;
      }
    },
    testC() {
      if (this.questionTypeSelected === 'تستی') {
        if (this.testC === '') {
          this.testCErr = true;
        } else {
          this.testCErr = false;
        }
      } else {
        this.testCErr = false;
      }
    },
    testD() {
      if (this.questionTypeSelected === 'تستی') {
        if (this.testD === '') {
          this.testDErr = true;
        } else {
          this.testDErr = false;
        }
      } else {
        this.testDErr = false;
      }
    },
    qLevel() {
      if (this.qLevel === '') {
        this.qLevelErr = true;
      } else {
        this.qLevelErr = false;
      }
    },
    qLessonId() {
      if (this.qLessonId === '') {
        this.qLessonIdErr = true;
      } else {
        this.qLessonIdErr = false;
      }
    },
    isSubcats() {
      if (this.isSubcats) {
        this.getClassification();
      }
    },
    // editor
    content() {
      // console.clear();
      // console.log(this.content);
    },
  },
  computed: {
    isAddQuestionReady() {
      // اینجا باید ببینیم کدوم یکی از دوحالت زیر هستند
      // field
      const justClassification = this.qSelectedFieldErr
        && this.qSelectedGradeIdErr
        && this.qLessonIdErr;
      const optionalClassification = !this.qSelectedFieldErr;
      this.setClassification(justClassification, optionalClassification);
      // console.warn(justClassification);
      // console.warn(optionalClassification);
      // console.warn('---------');
      const isTest = this.questionTypeSelected === 'تستی';
      let isFormValid = false;
      // //////////////////////
      if (isTest) {
        if (justClassification) {
          isFormValid = !this.questionErr
            && !this.tTrueAnsErr
            && (!this.testAErr || this.testAMedia !== '')
            && (!this.testBErr || this.testBMedia !== '')
            && (!this.testCErr || this.testCMedia !== '')
            && (!this.testDErr || this.testDMedia !== '')
            && !this.qTypeSelectedErr
            && !this.qLevelErr
            && !this.qClassificationIdErr;
        } else if (optionalClassification) {
          isFormValid = !this.questionErr
            && !this.tTrueAnsErr
            && (!this.testAErr || this.testAMedia !== '')
            && (!this.testBErr || this.testBMedia !== '')
            && (!this.testCErr || this.testCMedia !== '')
            && (!this.testDErr || this.testDMedia !== '')
            && !this.qTypeSelectedErr
            && !this.qLevelErr
            && !this.qSelectedFieldErr
            && !this.qSelectedGradeIdErr
            && !this.qLessonIdErr;
        }
      } else {
        // eslint-disable-next-line
        if (justClassification) {
          isFormValid = !this.questionErr
            && !this.qTypeSelectedErr
            && !this.qLevelErr
            && !this.qClassificationIdErr;
        } else if (optionalClassification) {
          isFormValid = !this.questionErr
            && !this.qTypeSelectedErr
            && !this.qLevelErr
            && !this.qSelectedFieldErr
            && !this.qSelectedGradeIdErr
            && !this.qLessonIdErr;
        }
      }
      return isFormValid;
    },
    isEditQuestionReady() {
      if (this.questionTypeSelected === 'تستی') {
        // eslint-disable-next-line
        return !this.questionErr && !this.tTrueAnsErr && (!this.testAErr || this.testAMedia !== '') && (!this.testBErr || this.testBMedia !== '') && (!this.testCErr || this.testCMedia !== '') && (!this.testDErr || this.testDMedia !== '');
      }
      // eslint-disable-next-line
      return !this.questionErr;
    },
    subCatErr() {
      return this.subcatName !== '';
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$store.commit('setLoadingOff');
      this.getClassification();
      this.getFields();
      window.katex = katex;
      EventBus.$on('edit', (id) => {
        this.initEdit(id);
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.sepline {
  height: 24px;
  margin: 0 4px;
  border-left: dashed 1px var(--normalText25);
}
// new for exam ↓↓↓
.bank, .newExam, .examsList {
  margin-top: 16px;
  .addQuestion {
    padding-left: 16px;
    .isTrueCheckBox {
      width: 24px;
      height: 24px;
      color: var(--normalText5);
      padding: 8px;
      margin-left: 8px;
      border: solid 2px var(--normalText5);
      border-radius: 4px;
      position: relative;
      cursor: pointer;
      * {
        pointer-events: none;
      }
      .tick {
        position: absolute;
        width: 0px;
        top: 8px;
        left: 8px;
        height: 0px;
        border: solid 4px var(--themeWhite85);
        border-top: none;
        border-left: none;
        transform: rotate(45deg);
      }
    }
    .isTrueCheckBox:hover {
      border-color: var(--themeGreen3);
    }
    .isTrueCheckBox.selected {
      border-color: var(--themeGreen);
      .tick {
        border-color: var(--themeGreen);
        width: 12px;
        top: -8px;
        left: 8px;
        height: 24px;
      }
    }
    .qDetail {
      padding: 8px;
      border-right: solid 2px var(--normalText15);
      h5 {
        font-size: 10px;
        font-weight: 300;
      }
      span.ddd {
        font-size: 14px;
        font-weight: bold;
      }
    }
    .noQ {
      height: 112px;
      padding-right: 16px;
      margin-right: 2px;
      border-right: solid 2px var(--normalText15);
      span {
        font-size: 16px;
        font-weight: 100;
        color: var(--normalText);
      }
      span.m {
        font-size: 12px;
        font-weight: 300;
        color: var(--normalText);
      }
    }
    ul {
      padding: 0;
      margin: 0;
      max-height: 350px;
      border-radius: 8px;
      border: solid 1px var(--normalText05);
      overflow: hidden auto;
      li {
        list-style-type: none;
        padding: 16px;
        border-bottom: 1px solid var(--normalText05);
        .qindex {
          width: 24px;
          min-width: 24px;
          font-size: 10px;
          font-weight: 300;
          text-align: right;
        }
        .qQuestion {
          span.q {
            font-size: 13px;
            font-weight: bold;
            text-align: right;
          }
          i {
            margin-left: 8px;
            opacity: 0.5;
            transition: all ease-in-out 0.3s;
          }
          i:hover {
            opacity: 1;
          }
          i.hard {
            color: var(--themeRed);
          }
          i.normal {
            color: var(--themeGreen);
          }
          i.easy {
            color: var(--themeBlue);
          }
          .qOptions {
            p {
              font-size: 12px;
              text-align: right;
              margin-top: 8px;
              font-weight: bold;
            }
          }
        }
        input[type='number'] {
          width: 80px;
          margin-left: 8px;
        }
      }
      li.selected {
        background-color: var(--normalText05);
      }
      li:hover {
        background-color: rgba($color: #000000, $alpha: 0.0) !important;
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.0);
      }
    }
  }
}
.gridItem {
  height: 64px;
}
textarea.qo {
  min-height: 112px;
  resize: none;
}
.minilist {
  box-shadow: 0 8px 16px 0 rgba($color: #000000, $alpha: 0.15);
  border-radius: 8px;
  overflow: hidden;
  .heads {
    width: 100%;
    text-align: right;
    padding: 8px;
    word-spacing: -2px;
    font-size: 14px;
    color: var(--themeWhite);
    font-weight: 400;
    background-color: var(--primary);
    i {
      margin-left: 8px;
      font-size: 16px;
      color: var(--themeWhite);
      padding: 8px;
    }
  }
  ul.minilistUl {
    padding: 0;
    margin: 0;
    overflow: hidden auto;
    li {
      width: 100%;
      padding: 12px;
      list-style: none;
      text-align: right;
      border-bottom: dashed 1px var(--normalText15);
      span {
        width: 16px;
        font-size: 10px;
        font-weight: 200;
        text-align: right;
      }
      .title {
        font-size: 14px;
        font-weight: bold;
      }
      .desc {
        font-size: 10px;
        font-weight: 300;
      }
      input.editableItem {
        font-size: 14px;
        padding: 8px 0;
        border: none !important;
      }
      input.editableItem:focus {
        border-width: 0 0 1px 0;
        border-bottom: solid 1px var(--normalText15);
      }
    }
  }
}
// new for exam ↑↑↑
  .counter{
    min-width: 96px;
    label{
      font-weight: bold;
      margin-right: 8px;
      font-size: 32px;
      color: var(--normalText8);
    }
    span{
      font-weight: 100;
      font-size: 12px;
      color: var(--normalText8);
    }
  }
  .courseInfoHolder {
    $iw: 204px;
    padding: 24px;
    margin-bottom: 24px;
    border-bottom: dashed 1px var(--normalText15);
    img.c{
      width: $iw;
      height: $iw;
      border-radius: 8px;
    }
    .courseTeacher{
      font-size: 16px;
      word-spacing: -2px;
      font-weight: 400;
    }
    .courseLesson{
      font-size: 13px;
      word-spacing: 0px;
      font-weight: 400;
    }
    .courseName{
      font-size: 28px;
      word-spacing: -2px;
      font-weight: 400;
      color: #61187A;
      text-align: right;
      line-height: 1.3;
      border-right: solid 4px var(--primary);
      padding: 0px 8px 0 0;
    }
  }

  .infos{
    padding: 0 24px;
  }
  .courseId{
    padding: 2px 8px;
    font-size: 10px;
    margin-bottom: 16px;
    letter-spacing: 2px;
    border-right: solid 4px rgba($color: #000000, $alpha: 0.2);
  }
  .courseSummary{
    padding: 8px 8px 16px;
    font-size: 12px;
    text-align: right;
    color: #646464;
    border-right: solid 4px rgba($color: #000000, $alpha: 0.2);
  }

  .teacherHolder img.t{
    width: 64px;
    height: 64px;
    margin-left: 8px;
    border-radius: 80px 0 80px 80px;
  }

  .question{
    font-size: 18px;
    font-weight: 300;
    margin-bottom: 16px;
    text-align: right;
  }

  .ltr {
    direction: ltr !important;
  }

  .rules{
    margin: 24px 24px 50px;
  }

  .ruleBox {
    padding: 0 8px;
  }

  .newExam h3, .examsList h3 {
    width: 100%;
    text-align: right;
    padding: 8px 16px;
    word-spacing: -2px;
    font-size: 20px;
    font-weight: 400;
  }

  .newExam h4, .examsList h4 {
    width: 100%;
    text-align: right;
    padding: 8px 16px;
    word-spacing: -2px;
    font-size: 14px;
    font-weight: 200;
    position: relative;
  }

  .newExam h4::before, .examsList h4::before{
    position: absolute;
    content: ' ';
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background-color: var(--themeBlue);
    left: calc(100% - 8px);
    top: 50%;
    transform: translateY(-50%);
  }

  .newExam p, .examsList p {
    width: 100%;
    text-align: right;
    padding: 0px 16px;
    word-spacing: -1px;
    font-size: 12px;
    font-weight: 200;
    margin: 0 0 4px 0;
    position: relative;
  }

  .newExam p::before, .examsList p::before{
    position: absolute;
    content: ' ';
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background-color: var(--secondary);
    left: calc(100% - 8px);
    top: 5px;
  }

  input[type="text"], input[type='number'] {
    border-radius: 4px;
    border: solid 1px var(--normalText);
    padding: 4px 8px;
    font-size: 13px;
    font-weight: 200;
    width: 100%;
  }
  // reseeet
  .reset-this {
    animation : none;
    animation-delay : 0;
    animation-direction : normal;
    animation-duration : 0;
    animation-fill-mode : none;
    animation-iteration-count : 1;
    animation-name : none;
    animation-play-state : running;
    animation-timing-function : ease;
    backface-visibility : visible;
    background : 0;
    background-attachment : scroll;
    background-clip : border-box;
    background-color : transparent;
    background-image : none;
    background-origin : padding-box;
    background-position : 0 0;
    background-position-x : 0;
    background-position-y : 0;
    background-repeat : repeat;
    background-size : auto auto;
    border : 0;
    border-style : none;
    border-width : medium;
    border-color : inherit;
    border-bottom : 0;
    border-bottom-color : inherit;
    border-bottom-left-radius : 0;
    border-bottom-right-radius : 0;
    border-bottom-style : none;
    border-bottom-width : medium;
    border-collapse : separate;
    border-image : none;
    border-left : 0;
    border-left-color : inherit;
    border-left-style : none;
    border-left-width : medium;
    border-radius : 0;
    border-right : 0;
    border-right-color : inherit;
    border-right-style : none;
    border-right-width : medium;
    border-spacing : 0;
    border-top : 0;
    border-top-color : inherit;
    border-top-left-radius : 0;
    border-top-right-radius : 0;
    border-top-style : none;
    border-top-width : medium;
    bottom : auto;
    box-shadow : none;
    box-sizing : content-box;
    caption-side : top;
    clear : none;
    clip : auto;
    color : inherit;
    columns : auto;
    column-count : auto;
    column-fill : balance;
    column-gap : normal;
    column-rule : medium none currentColor;
    column-rule-color : currentColor;
    column-rule-style : none;
    column-rule-width : none;
    column-span : 1;
    column-width : auto;
    content : normal;
    counter-increment : none;
    counter-reset : none;
    cursor : auto;
    direction : ltr;
    display : inline;
    empty-cells : show;
    float : none;
    font : normal;
    font-family : inherit;
    font-size : medium;
    font-style : normal;
    font-variant : normal;
    font-weight : normal;
    height : auto;
    hyphens : none;
    left : auto;
    letter-spacing : normal;
    line-height : normal;
    list-style : none;
    list-style-image : none;
    list-style-position : outside;
    list-style-type : disc;
    margin : 0;
    margin-bottom : 0;
    margin-left : 0;
    margin-right : 0;
    margin-top : 0;
    max-height : none;
    max-width : none;
    min-height : 0;
    min-width : 0;
    opacity : 1;
    orphans : 0;
    outline : 0;
    outline-color : invert;
    outline-style : none;
    outline-width : medium;
    overflow : visible;
    overflow-x : visible;
    overflow-y : visible;
    padding : 0;
    padding-bottom : 0;
    padding-left : 0;
    padding-right : 0;
    padding-top : 0;
    page-break-after : auto;
    page-break-before : auto;
    page-break-inside : auto;
    perspective : none;
    perspective-origin : 50% 50%;
    position : static;
    /* May need to alter quotes for different locales (e.g fr) */
    quotes : '\201C' '\201D' '\2018' '\2019';
    right : auto;
    tab-size : 8;
    table-layout : auto;
    text-align : inherit;
    text-align-last : auto;
    text-decoration : none;
    text-decoration-color : inherit;
    text-decoration-line : none;
    text-decoration-style : solid;
    text-indent : 0;
    text-shadow : none;
    text-transform : none;
    top : auto;
    transform : none;
    transform-style : flat;
    transition : none;
    transition-delay : 0s;
    transition-duration : 0s;
    transition-property : none;
    transition-timing-function : ease;
    unicode-bidi : normal;
    vertical-align : baseline;
    visibility : visible;
    white-space : normal;
    widows : 0;
    width : auto;
    word-spacing : normal;
    z-index : auto;
    /* basic modern patch */
    all: initial;
    all: unset;
}

/* basic modern patch */

#reset-this-root {
    all: initial;
    * {
        all: unset;
    }
}

.qlClass {
  margin-bottom: 8px;
}

.sectionHead {
    font-size: 12px;
    color: var(--normalText5);
    position: relative;
    margin-bottom: 12px;
    i{
      color: var(--normalText35);
      font-size: 16px;
      margin-left: 8px;
    }
  }
.howToFormula {
  margin-right: 16px;
  border-radius: 24px;
  padding: 4px 16px;
  background-color: var(--themeBlue);
  color: var(--themeWhite);
  text-decoration: none;
}
</style>
